import { createContext, Dispatch, SetStateAction } from "react";

// ---------------------------------------------------------------------------
// AppContext
// ---------------------------------------------------------------------------
// Holds admin-specific state not covered by sj-ui-toolkit's UserContext or
// SettingsContext. Consuming components should access this via useContext.
// ---------------------------------------------------------------------------

export interface AppContextState {
  isSjSuperAdmin: boolean;
  isSjUser: boolean;
  isSjGuest: boolean;
  isSjGuestAdmin: boolean;
  viewOnly: boolean;
  tryUsAccess: boolean;
  pathAccess: boolean;
  showFeedback: boolean;
  showContacts: boolean;
}

export interface AppContextValue {
  state: AppContextState;
  setState: Dispatch<SetStateAction<AppContextState>>;
}

export const defaultAppState: AppContextState = {
  isSjSuperAdmin: false,
  isSjUser: false,
  isSjGuest: false,
  isSjGuestAdmin: false,
  viewOnly: false,
  tryUsAccess: false,
  pathAccess: false,
  showFeedback: false,
  showContacts: false,
};

export const AppContext = createContext<AppContextValue>({
  state: defaultAppState,
  setState: () => undefined,
});
